<template>
  <div class="version-detail">
    <div v-if="!obj.title" class="no-data">
      未找到版本说明！
    </div>
    <div v-if="obj.title" class="title">{{ obj.title }}</div>
    <div v-if="obj.content" class="list-con">
      <div class="list" v-for="(item, i) in obj.content" :key="i">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
  import ios from './data/ios'
  export default {
    props: ['ver'],
    data(){
      return {
        ios,
        obj: {}
      }
    },
    created(){
      if(this.ios[this.ver]){
        this.obj = this.ios[this.ver]
      }else {
        this.obj = {
          title: '',
          content: []
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  .version-detail{
    padding: 6px 12px 36px;
    .no-data{
      text-align: center;
      font-size: 16px;
      line-height: 40px;
      color: #747474;
    }
    .title{
      line-height: 36px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 6px;
    }
    .list-con{
      line-height: 1.4;
      font-size: 14px;
      text-indent: 2em;
      .list{
        margin-bottom: 6px;
      }
    }
  }

</style>